const BLUE = "#1E4FA0";
const PINK = "#D6206E";

const Spark = ({ x, y, scale = 1 }) => (
  <path
    d="M0,-4.2 L1,-1 L4.2,0 L1,1 L0,4.2 L-1,1 L-4.2,0 L-1,-1 Z"
    fill={BLUE}
    transform={`translate(${x} ${y}) scale(${scale})`}
  />
);

export const EstdBadge = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
    <circle cx="100" cy="100" r="92" fill="none" stroke={BLUE} strokeWidth="3" />
    <circle cx="100" cy="100" r="84" fill="none" stroke={BLUE} strokeWidth="1.25" />

    <path id="estdArcTop" d="M 36.1,76.74 A 68,68 0 0 1 163.9,76.74" fill="none" />
    <path id="estdArcBottom" d="M 34.32,117.6 A 68,68 0 0 0 165.68,117.6" fill="none" />

    <text fill={BLUE} fontFamily="Outfit, sans-serif" fontSize="13" fontWeight="600" letterSpacing="2.5">
      <textPath href="#estdArcTop" startOffset="50%" textAnchor="middle">
        ESTD. 1997
      </textPath>
    </text>

    <text fill={BLUE} fontFamily="Outfit, sans-serif" fontSize="10.5" fontWeight="600" letterSpacing="2">
      <textPath href="#estdArcBottom" startOffset="50%" textAnchor="middle">
        THE RAILWAY ADVERTISER
      </textPath>
    </text>

    <text
      x="100"
      y="111"
      textAnchor="middle"
      fill={PINK}
      fontFamily="Cormorant Garamond, serif"
      fontStyle="italic"
      fontWeight="600"
      fontSize="34"
    >
      Twins Media
    </text>

    <Spark x="26.7" y="73.3" />
    <Spark x="173.3" y="73.3" />
    <circle cx="24.7" cy="120.2" r="2.1" fill={BLUE} />
    <circle cx="175.3" cy="120.2" r="2.1" fill={BLUE} />
  </svg>
);
